import { render, staticRenderFns } from "./BlockTypeTraining.vue?vue&type=template&id=6aba15e4&scoped=true&"
import script from "./BlockTypeTraining.vue?vue&type=script&lang=js&"
export * from "./BlockTypeTraining.vue?vue&type=script&lang=js&"
import style0 from "./BlockTypeTraining.vue?vue&type=style&index=0&id=6aba15e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba15e4",
  null
  
)

export default component.exports